// src/utils/authUtils.ts - PROPER LOGOUT FUNCTION
import unifiedAuth from './unifiedAuth';

export const performCompleteLogout = async () => {
  // 1. Revoke the token server-side.
  //
  // This used to be a fetch written out here, and it had never once succeeded: it
  // posted to `/auth/logout/` with a trailing slash, and Spring Boot 3 dropped
  // trailing-slash matching, so every call 404'd inside a catch that swallowed the
  // failure. There was also no such endpoint until now. It was additionally gated on
  // the *refresh* token existing while sending the *access* token, so a session
  // holding only an access token skipped the call entirely, and it had no timeout -
  // a stalled network meant the user was never logged out locally either, because
  // the clearing below sits after the await.
  //
  // Delegated to unifiedAuth so exactly one place in the app knows how to talk to
  // the endpoint. It has its own timeout and swallows its own failures.
  await unifiedAuth.auth.logout();
  
  // 2. FORCE CLEAR ALL AUTH DATA (this is the critical part)
  
  // Clear all auth-related localStorage items
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token'); 
  localStorage.removeItem('account');
  localStorage.removeItem('user_preferences');
  localStorage.removeItem('keep_session');
  
  // Clear any other auth-related items that might exist
  const authKeys = Object.keys(localStorage).filter(key => 
    key.includes('token') || 
    key.includes('auth') || 
    key.includes('user') ||
    key.includes('session')
  );
  
  authKeys.forEach(key => {
    localStorage.removeItem(key);
  });
  
  // Clear sessionStorage too
  sessionStorage.clear();
  
  // 3. Force redirect to login (important!)
  window.location.replace('/login');
};

// Enhanced storage clearing function
export const clearAllAuthData = () => {
  // Clear specific known auth keys
  const authKeys = [
    'access_token',
    'refresh_token', 
    'account',
    'user_preferences',
    'keep_session',
    'user_session',
    'auth_token',
    'token',
    'user',
    'userInfo'
  ];
  
  authKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
    }
  });
  
  // Clear everything that might be auth-related
  Object.keys(localStorage).forEach(key => {
    if (key.toLowerCase().includes('token') || 
        key.toLowerCase().includes('auth') || 
        key.toLowerCase().includes('user') ||
        key.toLowerCase().includes('session')) {
      localStorage.removeItem(key);
    }
  });
  
  // Clear sessionStorage
  sessionStorage.clear();
};